var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00019 1.6665L2.5 5.00009V16.6676C2.5 17.1097 2.67561 17.5337 2.98819 17.8462C3.30078 18.1588 3.72473 18.3344 4.16679 18.3344H15.8343C16.2764 18.3344 16.7004 18.1588 17.013 17.8462C17.3255 17.5337 17.5011 17.1097 17.5011 16.6676V5.00009L15.001 1.6665H5.00019Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.335 8.33398C13.335 9.21822 12.9837 10.0662 12.3585 10.6915C11.7332 11.3167 10.8852 11.668 10.001 11.668C9.11676 11.668 8.26875 11.3167 7.6435 10.6915C7.01825 10.0662 6.66699 9.21822 6.66699 8.33398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.00049H17.5011",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbag);
export default __webpack_public_path__ + "static/media/shoppingbag.86b4618b7fd6825b032e45ac77972354.svg";
export { ForwardRef as ReactComponent };